import Axios from "axios";
import {
	Notification,
	Message
} from 'element-ui'
import {
	getToken
} from '../untils/func'

Axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
Axios.defaults.headers['myClientTYpe'] = 'pc'
Axios.defaults.baseURL = '/api'

const instance = Axios.create({
	timeout: 1000 * 60
});

// request拦截器
instance.interceptors.request.use(
	config => {

		config.headers['myToken'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
		return config
	},
	// error => {
	//     console.log(error)
	//     Promise.reject(error)
	// }
)

// 响应拦截器
instance.interceptors.response.use(res => {

		if (res.config.url == '/file/load') {
			return res;
		}

		const code = res.data.statusCode
		if (code == 2) {
			for (let i = 0; i < window.myTimer.length; i++) {
				clearInterval(window.myTimer[i])
			}
			window.vueInstance.$confirm('登录超时需重新登录', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				window.vueInstance.$router.push("/");
				return Promise.reject();
			}).catch(() => {
				window.vueInstance.$router.push("/");
				return Promise.reject('error');
			});


			// window.vueInstance.$router.push("/");
			// return Promise.reject();
		} else if (code != 1) {
			Notification.error({
				title: res.data.statusMsg
			})
			return Promise.reject('error')
		} else {
			return res.data;
		}
	},
	error => {
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)
export default instance;
